<template>
	<div class="no-forms">
		<img
			class="no-forms__img"
			src="~@/assets/no-forms.svg"
			alt="no forms image"
		/>
		<h2 class="no-forms__title">
			{{ title }}
		</h2>
		<p class="no-forms__message">
			{{ message }}
		</p>
	</div>
</template>

<script>
export default {
	Name: 'NoForms',
	props: {
		title: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: 'Click the New Form button above to add one.'
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * No forms
    * Can use SCSS variables = TRUE
*/

.no-forms {
	padding: $padding-sm * 9 0;
	margin: 0 auto;
	max-width: 420px;
	text-align: center;

	&__img {
		height: auto;
	}

	&__title {
		font-size: $default-font-size + 4;
		margin-bottom: $gutter-md;
		font-weight: $medium-font-weight;
		line-height: normal;
		@include text-contrast($page-body-bkgd, $white, $black);
	}

	&__message {
		font-size: $default-font-size - 2;
		@include text-contrast($page-body-bkgd, $white, $black);
	}
}
</style>
